export default "__VITE_ASSET__CSdINTOp__"